/**
 * @generated SignedSource<<a86f1b44c6afd79f0319020cb5d5f3a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "accountDelegatedAuthsId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "accountDelegatedAuthsId",
    "variableName": "accountDelegatedAuthsId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appName",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "authType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appData",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appDescription",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "appLogo",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountDelegatedAuthsMapId",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mapName",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityName",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityDescription",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "IntegrationSetupXeroQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountDelegatedAuthsT",
        "kind": "LinkedField",
        "name": "accountDelegatedAuthsTByAccountDelegatedAuthsId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AppIntegrationT",
            "kind": "LinkedField",
            "name": "appIntegrationTByAppIntegrationId",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDelegatedAuthsMapTsConnection",
            "kind": "LinkedField",
            "name": "accountDelegatedAuthsMapTsByAccountDelegatedAuthsId",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountDelegatedAuthsMapT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "IntegrationSetupXeroQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "AccountDelegatedAuthsT",
        "kind": "LinkedField",
        "name": "accountDelegatedAuthsTByAccountDelegatedAuthsId",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "AppIntegrationT",
            "kind": "LinkedField",
            "name": "appIntegrationTByAppIntegrationId",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              (v13/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "AccountDelegatedAuthsMapTsConnection",
            "kind": "LinkedField",
            "name": "accountDelegatedAuthsMapTsByAccountDelegatedAuthsId",
            "plural": false,
            "selections": [
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "AccountDelegatedAuthsMapT",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  (v8/*: any*/),
                  (v9/*: any*/),
                  (v10/*: any*/),
                  (v11/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v13/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "73d0954e01e8dd875ee19b33efbe4a5b",
    "id": null,
    "metadata": {},
    "name": "IntegrationSetupXeroQuery",
    "operationKind": "query",
    "text": "query IntegrationSetupXeroQuery(\n  $accountDelegatedAuthsId: UUID!\n) {\n  accountDelegatedAuthsTByAccountDelegatedAuthsId(accountDelegatedAuthsId: $accountDelegatedAuthsId) {\n    appName\n    authType\n    appData\n    appIntegrationTByAppIntegrationId {\n      appDescription\n      appLogo\n      nodeId\n    }\n    accountDelegatedAuthsMapTsByAccountDelegatedAuthsId {\n      totalCount\n      nodes {\n        accountDelegatedAuthsMapId\n        mapName\n        entityId\n        entityName\n        entityDescription\n        nodeId\n      }\n    }\n    nodeId\n  }\n}\n"
  }
};
})();

node.hash = "496c8adc8b6faaa3bcdad075f528aa9b";

module.exports = node;
